import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { Subject, combineLatest, filter, takeUntil, tap } from 'rxjs';
import { CashAdvanceMoneyHelpCardComponent } from './home-cards/cash-advance-money-help-card/cash-advance-money-help-card.component';
import { CashAdvanceRepaymentsCardComponent } from './home-cards/cash-advance-repayments-card/cash-advance-repayments-card.component';

@Injectable({ providedIn: 'root' })
export class CashAdvanceCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);

  private _cashAdvanceIventontory$ = this._serviceInventory.getService('cash_advance');
  private _spendingIventontory$ = this._serviceInventory.getService('spending');
  private _unsub$ = new Subject<void>();

  constructor() {
    combineLatest([this._cashAdvanceIventontory$, this._spendingIventontory$])
      .pipe(
        filter(([cashAdvance, spending]) => !!cashAdvance && !!spending),
        filter(([cashAdvance]) => cashAdvance.state === ServiceState.INITIAL),
        tap(([, spending]) => {
          if (spending.state === ServiceState.COMPLETE) {
            this.registerCashAdvanceMoneyHelpCard('spending_dashboard');
          } else {            
            this.registerCashAdvanceMoneyHelpCard();
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();

    this._serviceInventory
      .getService('cash_advance')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.READY:
              this.registerCashAdvanceMoneyHelpCard('cash_advance');
              break;
            case ServiceState.PENDING:
              this.registerCashAdvanceMoneyHelpCard('cash_advance');
              this.registerCashAdvanceRepaymentsCard();
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private registerCashAdvanceMoneyHelpCard(route?: string) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'cash-advance',
      component: 'CashAdvanceInitialCardComponent',
      componentRef: CashAdvanceMoneyHelpCardComponent,
      section: HomeFeedSection.MYMONEYHELP,
      data: { route },
      order: 2,
    });
  }

  private registerCashAdvanceRepaymentsCard() {    
    this._homeFeedService.registerHomeFeedCard({
      key: 'cash-advance-repayments',
      component: 'CashAdvanceRepaymentsCardComponent',
      componentRef: CashAdvanceRepaymentsCardComponent,
      section: HomeFeedSection.REPAYMENTS,
      order: 2,
    });
  }
}
